

declare global {
    interface Window {
        TrackierWebSDK: any;
    }
  }
  

export function shooglooAffiliate(orderTotal: any,order_id:any,utmSource:any) {
    if (utmSource === "Affiliate_Shoogloo") {
        window.TrackierWebSDK.trackConvForBrand('tsm.s3g6.com', '654b60d0c8ff2f041916305c', {
            "is_camp": true,
            "txn_id": `${order_id}`,
            "sale_amount": `${orderTotal}`
          });
        
      }

}